var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Timer',{attrs:{"starttime":_vm.submission_start_date,"endtime":_vm.submission_end_date,"trans":"{  \n  \"day\":\"days\",\n  \"hours\":\"hours\",\n  \"minutes\":\"minutes\",\n  \"seconds\":\"seconds\",\n  \"expired\":\"Event has been expired.\",\n  \"running\":\"Till the end of event.\",\n  \"upcoming\":\"Till start of event.\",\n  \"status\": {\n  \"expired\":\"Expired\",\n  \"running\":\"Running\",\n  \"upcoming\":\"Future\"\n  }}"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8736490","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimerBox.vue
// module id = 101
// module chunks = 0